export default __webpack_public_path__ + "static/media/portfolio.cc820719.jpg";